import { schemeColor } from 'shared/assets/styles/scheme-color.style';
import { Button } from 'shared/components/ui/button';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
  padding-top: ${({ theme }) => theme.spacing(5)};
  padding-left: ${({ theme }) => theme.spacing(5)};
  padding-right: ${({ theme }) => theme.spacing(5)};
  padding-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const TopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};

  width: 100%;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const Body = styled.div<{ $completed: boolean }>`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
  margin-top: ${({ theme }) => theme.spacing(-1)};

  color: ${({ theme, $completed }) =>
    $completed ? theme.palette.text.secondary : 'inherit'};
`;

export const DescriptionContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing(0.5)};
  ${({ theme }) => typographyToCss(theme.typography.overline)};

  textarea::placeholder {
    color: ${({ theme }) => theme.palette.text.secondary};
    opacity: 1;
  }
`;

export const IllustrationContainer = styled.div`
  flex: 0 0 auto;
  position: relative;
  align-self: flex-start;
`;

export const ImageContainer = styled.div<{ $isProject?: boolean }>`
  position: relative;
  width: 5.6rem;
  height: 5.6rem;

  border-radius: ${({ theme }) => theme.spacing(2)};
  overflow: hidden;

  font-size: 2.4rem;
`;

export const ProjectIcon = styled.span<{ $color?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  background: ${({ theme }) => theme.palette.grey[100]};
  color: ${({ $color, theme }) => $color ?? theme.palette.grey[700]};
`;

export const ColorDot = styled.span<{ $color: string }>`
  position: absolute;
  bottom: ${({ theme }) => `-${theme.spacing(0.75)}`};
  right: ${({ theme }) => `-${theme.spacing(0.75)}`};

  display: block;
  height: 1.2rem;
  width: 1.2rem;

  border: ${({ theme }) =>
    `${theme.spacing(0.5)} solid ${theme.palette.background.default};`};
  border-radius: 50%;
  background: ${({ $color, theme }) => schemeColor($color, theme)};
`;

export const Anchor = styled.a`
  display: inline-block;
  max-width: 20rem;

  overflow: hidden;

  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: top;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primary.main};

  &:hover {
    text-decoration: underline;
  }
`;

export const ChipContainer = styled.div`
  display: flex;
`;

export const MetaContainer = styled.div`
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing(2)};
  row-gap: ${({ theme }) => theme.spacing(1)};

  min-width: 0;
`;

export const CompleteButton = styled(Button)`
  margin-left: ${({ theme }) => theme.spacing(2)};
`;

export const DeadlineValue = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  min-width: 0;
`;

export const DeadlineTimeLeft = styled.span`
  display: inline-flex;
  min-width: 0;

  color: ${({ theme }) => theme.palette.text.secondary};
`;
